import React from "react";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup.js";
import { Button } from "@pd/pd-ui-kit";
import { Flex } from "antd";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import CheckInCircleIcon from "~/components/Icons/svg/checkincircle";
import CheckInFileIcon from "~/components/Icons/svg/checkinfile";
import PrintIcon from "~/components/Icons/svg/print";
import { usePrintTemplate } from "~/entity/Contract";
import { useTemplateOptions } from "~/pages/ListOfDocuments/hooks/useTemplateOptions";
import { useTrustedPersons } from "~/pages/ListOfDocuments/hooks/useTrustedPersons";
import { formAdditional } from "~/pages/ListOfDocuments/Modals/options";
import { formResolverAdditional } from "~/pages/ListOfDocuments/schema";

import SelectedField from "./index";

import s from "./../style.less";

export const additionalFormId = "additionalForm";

interface FormContractIProps {
  defaultValues;
  submit: (data: any) => void;
  dealerId?: number;
  contractId?: number;
  printContract?: boolean;
}

export const FormAdditional = ({
  defaultValues,
  submit,
  contractId,
  dealerId,
  printContract,
}: FormContractIProps) => {
  const templates = useTemplateOptions();
  const { t } = useTranslation();
  const { print } = usePrintTemplate();
  const { control, watch, handleSubmit, setValue, errors, trigger } = useForm({
    defaultValues: defaultValues,
    resolver: yupResolver(formResolverAdditional(t)),
  });
  const { dataOptions } = useTrustedPersons();

  const addSignedByDealer = () => {
    setValue("dealerSignedDate", new Date());
    trigger("dealerSignedDate");
  };
  const addSignedByUrsos = () => {
    setValue("ursosSignedDate", new Date());
    trigger("ursosSignedDate");
  };

  return (
    <form
      id={additionalFormId}
      className={s.formWrapper}
      onSubmit={handleSubmit(submit)}
    >
      <div className={s.wrapperBlocks}>
        {formAdditional().map(({ title, fields }) => {
          return (
            <div key={title} className={s.titleBlockDocs}>
              <span className={s.itemBlockTitle}>{title}</span>
              <div className={s.itemWrappParent}>
                {fields.map((items) => {
                  return (
                    <div key={JSON.stringify(items)} className={s.itemsBlock}>
                      {items.map((item) => {
                        return (
                          <SelectedField
                            key={JSON.stringify(item)}
                            field={item.field}
                            type={item.type}
                            control={control}
                            name={item.name}
                            title={item.title}
                            position={item?.position ?? null}
                            readOnly={item?.readOnly}
                            errors={errors}
                            requisites={[{ value: "as", label: "fd" }]}
                            templates={templates}
                            dataOptions={dataOptions}
                          />
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
      <Flex gap={10} wrap>
        {dealerId && (
          <Button
            color="primary"
            bold
            transform="uppercase"
            disabled={!printContract}
            icon={<PrintIcon />}
            style={{ order: 1 }}
            size={"medium"}
            onClick={() => {
              print({
                contractId: contractId,
                dealerId: dealerId,
                requisitesId: defaultValues.vaz_requisitesId,
                contractNumber: watch("contractNumber"),
              });
            }}
          >
            Генерация соглашения
          </Button>
        )}
        <Button
          color="secondary"
          bold
          transform="uppercase"
          icon={<CheckInFileIcon />}
          style={{ order: dealerId ? 3 : 1 }}
          onClick={addSignedByDealer}
          size={"medium"}
        >
          Подписано дилером
        </Button>
        <Button
          color="secondary"
          bold
          transform="uppercase"
          icon={<CheckInCircleIcon />}
          style={{ order: 2 }}
          onClick={addSignedByUrsos}
          size={"medium"}
        >
          Подписано Урсос
        </Button>
      </Flex>
    </form>
  );
};
